<template>
	<div class="row centered">
		<AppTable ref="balance-transfers-table"
			v-if="userStore.currBusinessId"
			:fetch-function="fetchFunction"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('transfers_log')"
			:total-items="cardsStore.transfersLogTotal || 0"
			:items="cardsStore.transfersLog || []"
			initial-sort-field="created_at"
			@failed-fetch="details=>{$emit('failed-fetch', details)}"
			allow-download

			@export="exportTransfers" >
		</AppTable>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import {useCardsStore, useUserStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import {formatDateTimeWithSeconds} from "@/shared/helpers/dates";
import {exportToFile} from "@/shared/helpers/excel";

export default {
	setup() {
		const userStore = useUserStore();
		const cardsStore = useCardsStore();
		const languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		const notificationStore = useNotificationStore();
		return {userStore, cardsStore, getString: languageStore.getString, currencyStore, showNotification: notificationStore.showNotification}
	},
	name: "BalanceTransfersTable",
	emits: ["failed-fetch"],
	components: {AppTable},
	data() {
		return {
			filters: [
				{
					type: "date",
					key: 'created_at',
					tableName: 'cards_transfers_log',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 3,
					sortable: true,
					fieldName: 'created_at',
					formatter: 'date'
				},
				{
					text: this.getString('amount'),
					cols: 3,
					sortable: true,
					fieldName: 'amount',
					formatter: amount => this.currencyStore.readableCurrencyValue(amount, true, true, false)
				},
				{
					text: this.getString('type'),
					cols: 3,
					fieldName: 'type',
					formatter: type => this.getTransferType(type)
				},
				{
					text: this.getString('mode'),
					cols: 3,
					fieldName: 'mode',
					formatter: mode => this.getTransferMode(mode)
				},
			]
		}
	},
	computed: {
		fetchFunction() {
			return (filters, callback) => {
				this.cardsStore.getFilteredTransfersLog(this.userStore.currBusinessId, filters, callback);
			};
		}
	},
	methods: {
		getTransferType(type) {
			const typeMap = {
				'auto_recharge': this.getString('transfer_type_auto_recharge'),
				'manual': this.getString('transfer_type_manual'),
			};
			return typeMap[type] || type;
		},
		getTransferMode(mode) {
			const modeMap = {
				'minimum_balance': this.getString('transfer_mode_minimum_balance'),
				'percentage': this.getString('transfer_mode_percentage'),
				'bank_transfer': this.getString('transfer_mode_bank_transfer'),
				'balance_transfer': this.getString('transfer_mode_balance_transfer'),
			};
			return modeMap[mode] || mode || '-';
		},
		exportTransfers(expExtension) {
			let sym = this.currencyStore.currCurrency.symbol;
			let businessNameNorm = this.userStore.currBusiness.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
			let today = new Date().toLocaleString();
			let fileName = businessNameNorm+"_"+this.getString('transfers_log').toLowerCase()+"_"+today;
			exportToFile({
				columns: [
					{ header: this.getString('date'), value: t => formatDateTimeWithSeconds(t.created_at, false) },
					{ header: this.getString('amount') + " " + sym, value: t => this.currencyStore.dbToActualValue(t.amount), type: 'number', numberFormat: '#,##0.00' },
					{ header: this.getString('type'), value: t => this.getTransferType(t.type) },
					{ header: this.getString('mode'), value: t => this.getTransferMode(t.mode) },
				],
				rows: this.cardsStore.transfersLog || [],
				fileName,
				sheetName: this.getString("transfers_log"),
				format: expExtension,
				onEmpty: () => this.showNotification('table-no-data'),
			});
		},
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== oldVal) {
				if(this.$refs['balance-transfers-table']) {
					this.$refs['balance-transfers-table'].fetchData();
				}
			}
		},
		'cardsStore.forceRefresh': function () {
			if(this.$refs['balance-transfers-table']) {
				this.$refs['balance-transfers-table'].fetchData();
			}
		}
	}
}
</script>
